import { useSelector } from "react-redux";
import store from "../../stores/store";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import {
  exportConfiguration,
  getProjectionCode,
  key,
  trans,
} from "../../lib/utils";
import { useEffect } from "react";
import { mapScaleLine } from "./mapUtils";

function MapSettingsPanel() {
  const mapGetPoints = useSelector(
    (state) => store.getState().map.mapGetPoints
  );

  const layers = useSelector((state) => store.getState().layers);
  const sources = useSelector((state) => store.getState().sources);
  const bookmarks = useSelector((state) => store.getState().map.bookmarks);

  const registeredLayerTree = useSelector(
    (state) => store.getState().registeredLayerTree.tree
  );

  const layerTree = useSelector((state) => store.getState().layerTree);

  const mapSettings = useSelector((state) => store.getState().map.settings);

  return (
    <div className="me-3 " key={key()}>
      <div className="mt-2">
        <div className="card small">
          <div className="card-header">
            <i className="fas fa-ruler-horizontal me-2"></i>
            {trans("Scale bar")}
          </div>
          <div className="card-body">
            <div className="mt-0">
              <label>{trans("Units")}</label>
              <select
                className="form-select form-select-sm mt-1"
                value={mapSettings.scale.units}
                onChange={(e) => {
                  store.dispatch({
                    type: "map/settings/scale/update",
                    payload: { property: "units", value: e.target.value },
                  });
                }}
              >
                <option value="degrees">{trans("Degrees")}</option>
                <option value="imperial">{trans("Imperial Inch")}</option>
                <option value="us">{trans("US Inch")}</option>
                <option value="nautical">{trans("Nautical mile")}</option>
                <option value="metric">{trans("Metric")}</option>
              </select>
            </div>
            <div className="mt-2">
              <label>{trans("Type")}</label>
              <select
                className="form-select form-select-sm mt-1"
                value={mapSettings.scale.type}
                onChange={(e) => {
                  store.dispatch({
                    type: "map/settings/scale/update",
                    payload: { property: "type", value: e.target.value },
                  });
                }}
              >
                <option value="scaleline">{trans("Scale Line")}</option>
                <option value="scalebar">{trans("Scale Bar")}</option>
              </select>
            </div>
            {mapSettings.scale.type === "scaleline" ? (
              <div className="mt-2">
                <label>
                  {trans("Steps")}: {mapSettings.scale.steps}
                </label>
                <input
                  className="form-range mt-1"
                  onChange={(e) => {
                    store.dispatch({
                      type: "map/settings/scale/update",
                      payload: { property: "steps", value: e.target.value },
                    });
                  }}
                  type="range"
                  min="1"
                  max="8"
                  value={mapSettings.scale.steps}
                />
              </div>
            ) : (
              ""
            )}
            <div className="mt-2">
              <input
                className="form-check-input me-2"
                type="checkbox"
                id="settings-scalebar-show"
                checked={mapSettings.scale.show}
                onChange={(e) => {
                  store.dispatch({
                    type: "map/settings/scale/update",
                    payload: { property: "show", value: e.target.checked },
                  });
                }}
              />
              <label
                className="form-check-label"
                htmlFor="settings-scalebar-show"
              >
                {trans("Show scale bar")}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div className="card small">
          <div className="card-header">
            <i className="fas fa-map me-2"></i>
            {trans("Map")}
          </div>
          <div className="card-body">
            <div className="mt-0">
              <label>{trans("Coordinate Projection system")}</label>
              <select
                className="form-select form-select-sm mt-2"
                value={mapSettings.projection}
                onChange={(e) => {
                  store.dispatch({
                    type: "map/settings/projection/update",
                    payload: e.target.value,
                  });
                }}
              >
                {window["appConfig"]()["projectionSystems"].map((opt) => {
                  return (
                    <option value={getProjectionCode(opt.code)}>
                      {opt.title}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <button
          className="btn btn-secondary text-white btn-sm"
          onClick={(e) => {
            exportConfiguration(
              layers,
              layerTree,
              registeredLayerTree,
              window["map"],
              bookmarks
            );
          }}
        >
          {trans("Export configuration")}
        </button>
      </div>
    </div>
  );
}

export default MapSettingsPanel;
